import React from "react";

type ResetZoomButtonProps = {
	onClick: () => void;
};

const ResetZoomButton: React.FC<ResetZoomButtonProps> = ({ onClick }) => {
	return (
		<button
			onClick={onClick}
			type="button"
			className="btn-text absolute top-2 right-2 text-white bg-[#86BC25]  btn-text px-[2vh] py-[0.5vh] focus:bg-[#86BC25] hover:bg-[#86BC25] disabled:bg-[#86BC25] disabled:opacity-[0.6] rounded-[5px]"
		>
			Reset Zoom
		</button>
	);
};

export default ResetZoomButton;
